import { render } from "./HotZb.vue?vue&type=template&id=4268fbc2&scoped=true&ts=true"
import script from "./HotZb.vue?vue&type=script&setup=true&lang=ts"
export * from "./HotZb.vue?vue&type=script&setup=true&lang=ts"

import "./HotZb.vue?vue&type=style&index=0&id=4268fbc2&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4268fbc2"],['__file',"src/views/home/HotZb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4268fbc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4268fbc2', __exports__)) {
    console.log('reload')
    api.reload('4268fbc2', __exports__)
  }
  
  module.hot.accept("./HotZb.vue?vue&type=template&id=4268fbc2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('4268fbc2', render)
  })

}


export default __exports__